import { SAVE_AUTH_TOKEN, SAVE_PISYS_TOKEN } from "../actions/ActionConstants";

export function savePisysToken(data) {
    return { type: SAVE_PISYS_TOKEN, data }
}
export function saveAuthToken(data) {
    return { type: SAVE_AUTH_TOKEN, data }
}